import find from 'lodash/find';
import {
    apiCallStatus,
    userCapabilities,
    userGatewayCapabilities,
} from 'helpers/constants';

export default class UserCapabilityHelper {

    constructor(capability) {
        if (capability) {
            this.userCapabilityList = capability?.data?.capabilityInfos;
            this.isUserCapabilityLoading = capability.loadingStatus && capability.loadingStatus === apiCallStatus.LOADING;
        }
    }

    hasCapability(capabilityToCheck) {
        let hasCapability = false;
        if (this.userCapabilityList) {
            const foundCapability = find(this.userCapabilityList, (capability) => capability.capabilityCode === capabilityToCheck);
            if (foundCapability) {
                hasCapability = foundCapability.isAvailable === true;
            }
        }
        return hasCapability;
    }

    isLoading() {
        return this.isUserCapabilityLoading;
    }

    isSet() {
        return !!this.userCapabilityList;
    }

    hasConditionMonitoringCapability() {
        return this.hasCapability(userCapabilities.conditionOverview);
    }

    hasNotificationSettingsCapability() {
        return this.hasCapability(userCapabilities.notificationSettings);
    }

    hasfleetOverviewReportDelete() {
        return this.hasCapability(userCapabilities.fleetOverviewReportDelete);
    }

    hasOperationalParametersLimitStatus() {
        return this.hasCapability(userCapabilities?.operationalParametersLimitStatus);
    }

    hasOperationalParametersEditDefault() {
        return this.hasCapability(userCapabilities?.operationalParametersEditDefault);
    }

    hasGatewayAdminViewCapability() {
        return this.hasCapability(userCapabilities.gatewayAdminView);
    }

    hasGatewayAdminReadView() {
        return this.hasCapability(userCapabilities.gatewayAdminReadView);
    }

    hasConditionOverviewSubscriptionFilter() {
        return this.hasCapability(userCapabilities.conditionOverviewSubscriptionFilter);
    }

    hasCiamViewCapability() {
        return this.hasCapability(userCapabilities.ciamView);
    }

    hasOperationalParametersMinMax() {
        return this.hasCapability(userCapabilities.operationalParametersMinMax);
    }

    hasGatewayMaintenanceModeCapability() {
        return this.hasCapability(userCapabilities.gatewayMaintenanceMode);
    }

    hasCopyOrganizationNotificationSettings() {
        return this.hasCapability(userCapabilities.copyOrganizationNotificationSettings);
    }

    hasMultiGraphTabViewCapability() {
        return this.hasCapability(userCapabilities.multiChartView);
    }

    hasParameterBackupLegacyView() {
        return this.hasCapability(userCapabilities.parameterBackupLegacyView);
    }

    hasParameterBackupView() {
        return this.hasCapability(userCapabilities.parameterBackupView);
    }

    hasChangedParameterListLegacyView() {
        return this.hasCapability(userCapabilities.changedParameterListLegacyView);
    }

    hasOperationalParametersEnergyCapability() {
        return this.hasCapability(userCapabilities.operationalParametersEnergy);
    }

    hasAssetAdminCapability() {
        return this.hasCapability(userCapabilities.assetAdmin);
    }

    hasTriggerParameterBackupViewCapability() {
        return this.hasCapability(userCapabilities.parameterBackupTriggerView);
    }

    hasChangedParameterListView() {
        return this.hasCapability(userCapabilities.changedParameterListView);
    }

    hasbulkUploadView() {
        return this.hasCapability(userCapabilities.bulkUploadView);
    }

    hasVibrationFFTLegacyUserCapability() {
        return this.hasCapability(userCapabilities.fftChartLegacy);
    }

    hasVibrationFFTV2UserCapability() {
        return this.hasCapability(userCapabilities.fftChart);
    }

    hasHistogramLegacyUserCapability() {
        return this.hasCapability(userCapabilities.histogramChartLegacy);
    }

    hasHistogramV2UserCapability() {
        return this.hasCapability(userCapabilities.histogramChart);
    }

    hasScatterLegacyUserCapability() {
        return this.hasCapability(userCapabilities.scatterChartLegacy);
    }

    hasTriggerParameterBackupCapability() {
        return this.hasCapability(userCapabilities.parameterBackupTrigger);
    }

    hasScatterV2UserCapability() {
        return this.hasCapability(userCapabilities.scatterChart);
    }

    hasntfChannelWebhookCapability() {
        return this.hasCapability(userCapabilities.ntfChannelWebhook);
    }

    hasDriveAdminCapability() {
        return this.hasCapability(userCapabilities.driveAdmin);
    }

    // CBM mSERVICE CAPABILITY
    hasAdvancedAnalyticsV2Capability() {
        return this.hasCapability(userCapabilities.cbmChart);
    }

    hasGatewayFirmwareUpdateTrigger() {
        return this.hasCapability(userGatewayCapabilities.gatewayFirmwareUpdateTrigger);
    }

    hasExtractMessageArchive() {
        return this.hasCapability(userGatewayCapabilities.extractMessageArchive);
    }

    hasRebootGateway() {
        return this.hasCapability(userGatewayCapabilities.rebootGateway);
    }

    hasResetGateway() {
        return this.hasCapability(userGatewayCapabilities.resetGateway);
    }

    hasActivateRemoteConnection() {
        return this.hasCapability(userGatewayCapabilities.activateRemoteConnection);
    }

    hasGatewayDiagnosticTrigger() {
        return this.hasCapability(userGatewayCapabilities.gatewayDiagnosticTrigger);
    }

    hasIotDiagnosticReport() {
        return this.hasCapability(userGatewayCapabilities.iotDiagnosticReport);
    }

    /* FLEET DASHBOARD */
    hasFleetOverviewCapability() {
        return this.hasCapability(userCapabilities.fleetOverview);
    }

    hasHomePageCapability() {
        return this.hasCapability(userCapabilities.homePage);
    }

    hasHomePageRecCapability() {
        return this.hasCapability(userCapabilities.homePageREC);
    }

    /* CONDITION OVERVIEW V2 */
    hasConditionOverviewV2() {
        return this.hasCapability(userCapabilities.conditionOverviewnew);
    }

    /* CROSS ASSET ANALYSIS V2 */
    hasCrossAssetAnalysisV2() {
        return this.hasCapability(userCapabilities.crossAssetAnalysisV2);
    }

    hasDriveEventsSummary() {
        return this.hasCapability(userCapabilities.ciEventsCategorization);
    }

    hasMotorAnomalyDetection() {
        return this.hasCapability(userCapabilities.motorAnomalyDetection);
    }


    hasPowertrainConfiguratorCapability() {
        return this.hasCapability(userCapabilities.powertrainConfigurator);
    }

    hasPowertrainConfiguratorOldCapability() {
        return this.hasCapability(userCapabilities.powertrainConfiguratorOld);
    }

    hasExpertReportUpload() {
        return this.hasCapability(userCapabilities.expertReportUpload);
    }

    hasDeleteEventCommentsFromOtherUsers() {
        return this.hasCapability(userCapabilities.deleteEventCommentsFromOtherUsers);
    }

    hasOperationalParametersComments() {
        return this.hasCapability(userCapabilities.operationalParametersComments);
    }

    hasRecRegularReportUpload() {
        return this.hasCapability(userCapabilities.regularReportUploadRec);
    }

    hasDriveAnomalyDetection() {
        return this.hasCapability(userCapabilities.driveAnomalyDetection);
    }

    hasDriveEnergyOutlierDetection() {
        return this.hasCapability(userCapabilities.driveEnergyOutlierDetection);
    }

    hasDriveACS1000AnomalyDetection() {
        return this.hasCapability(userCapabilities.driveACS1000AnomalyDetection);
    }

    hasFFTEChart3DCapability() {
        return this.hasCapability(userCapabilities.fftechart3D);
    }

    hasMotorAnomalyRetraining() {
        return this.hasCapability(userCapabilities.motorAnomalyRetraining);
    }

    // This capability is used to gate the ability to import asset groups to location groups in the asset management module
    hasImportAssetGroupToLocation() {
        return this.hasCapability(userCapabilities.importAssetGroupToLocation);
    }

    // This capability is used to gate the ability to edit hierarchy configuration in the powertrain configurator details page and convert PT to location functionality.
    hasHierarchyConfiguration() {
        return this.hasCapability(userCapabilities.hierarchyConfiguration);
    }

    hasDriveAnomalyRetraining() {
        return this.hasCapability(userCapabilities.driveAnomalyRetraining);
    }
}
